/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetContainerQueryResult } from '../../models/get-container-query-result';

export interface ApiContainersGetContainerGet$Plain$Params {
  Id?: string;
}

export function apiContainersGetContainerGet$Plain(http: HttpClient, rootUrl: string, params?: ApiContainersGetContainerGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContainerQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiContainersGetContainerGet$Plain.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetContainerQueryResult>;
    })
  );
}

apiContainersGetContainerGet$Plain.PATH = '/api/Containers/GetContainer';
